import { Group, Paper, Stack, ThemeIcon, Text } from '@mantine/core';
import { formatCodeableConcept, formatHumanName } from '@medplum/core';
import { CodeableConcept, Patient, ServiceRequest } from '@medplum/fhirtypes';
import { IconClipboardText } from '@tabler/icons-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface OrderBannerProps {
  serviceRequest: ServiceRequest;
  patient: Patient;
  specimenType: CodeableConcept;
}

export const OrderBanner: FC<OrderBannerProps> = ({
  serviceRequest,
  patient,
  specimenType,
}) => {
  const { t } = useTranslation(['lims', 'common']);

  return (
    <Paper withBorder bg="blue.0">
      <Group p="md">
        <ThemeIcon bg="blue.3" size="lg">
          <IconClipboardText />
        </ThemeIcon>
        <Stack gap={0}>
          <Text fw={500} c="blue.8" tt="uppercase">
            {t('orderDetails.title', { ns: 'lims' })}{' '}
            {serviceRequest.identifier?.[0].value}
          </Text>
          <Group gap="xs">
            <Text fw={500}>{formatHumanName(patient?.name?.[0])}</Text>
            <Text fw={500}>•</Text>
            <Text>{formatCodeableConcept(specimenType)}</Text>
          </Group>
        </Stack>
      </Group>
    </Paper>
  );
};
